import { LessonTypesEnum } from 'types/generated/client';
import { ClinicTypeFilter, CourtTypeFilter } from './enums';
import { ClinicType } from './props';

export const DATE_RANGE_BUFFER = 60;

// External sources
export const EXTERNAL_SOURCE_PBP = 'pbp';

/** Max boosted clinics surfaced in the "Recommended for you" featured frame. */
export const MAX_FEATURED_CLINICS = 3;

export const CLINIC_TYPE_MATCH: Record<ClinicTypeFilter, (clinic: ClinicType) => boolean> = {
  [ClinicTypeFilter.Clinic]: (clinic) => clinic.type === LessonTypesEnum.Clinic,
  [ClinicTypeFilter.Fitness]: (clinic) =>
    clinic.type === LessonTypesEnum.Cardio || !!clinic.rfxEvent,
  [ClinicTypeFilter.Camp]: (clinic) => clinic.type === LessonTypesEnum.Camp,
};

export const CLINIC_TYPE_OPTIONS: { value: ClinicTypeFilter; label: string }[] = [
  { value: ClinicTypeFilter.Clinic, label: 'Clinic' },
  { value: ClinicTypeFilter.Fitness, label: 'Fitness' },
  { value: ClinicTypeFilter.Camp, label: 'Camp' },
];

export const COURT_TYPE_OPTIONS: { value: CourtTypeFilter; label: string }[] = [
  { value: CourtTypeFilter.Indoor, label: 'Indoor' },
  { value: CourtTypeFilter.Outdoor, label: 'Outdoor' },
];
